import { T } from "@tolgee/react";
import { FC } from "react";

export const BomPageExplainerTitle: FC = () => {
  return (
    <div className="text-base font-medium text-mandarin-900">
      <T keyName="pq-bom-t1-product-page-instructions-modal-title" />
    </div>
  );
};
